<div
	class="block-trigger-wrapper"
	[attr.aria-expanded]="focused"
	(click)="focused = true"
>
	@if (value?.contentType !== 'profile' || !value?.psId) {
		<au-logo-placeholder
			[logoSrc]="getLogoSrc()"
			[fallbackSrc]="getFallbackSrc()"
		></au-logo-placeholder>
	}

	@if (value?.contentType === 'profile' && value?.psId) {
		<au-round-avatar
			class="block-round-avatar"
			[data]="value"
			[size]="30"
		></au-round-avatar>
	}

	<p class="block-trigger-text" [class.placeholder]="!value">
		{{ blockTypePlaceholderText }}
	</p>
</div>
